import { Layout } from 'src/app/layout/layout.types';

// Theme type
export type Theme = 'light' | 'dark';

/**
 * AppConfig interface. Update this interface to strictly type your config
 * object.
 */
export interface AppConfig
{
    theme: Theme;
    layout: Layout;
}



function getLayoutFromLocalStorage(): Layout {
    const layout = localStorage.getItem('adminLayout') as Layout;
    return layout ? layout : 'compact';
}

export const appConfig: AppConfig = {
    theme : 'light',
    layout: getLayoutFromLocalStorage()
};
